module.exports = __webpack_public_path__ + "media/images/flags/1x1/jey-f4e690cbe60eff382d8689e35ca3e2ca.svg";